<template>
  <b-container fluid id="projects" class="page">
    <div
      class="title d-flex justify-content-between align-items-center flex-wrap"
    >
      <h1>Projects</h1>
      <b-button-group id="project-filter">
        <b-button
          id="active-btn"
          v-on:click="handleFilter"
          variant="light"
          value="Active"
          >Active</b-button
        >
        <b-button
          id="concluded-btn"
          v-on:click="handleFilter"
          variant="light"
          value="Concluded"
          >Concluded</b-button
        >
        <b-button
          v-on:click="handleFilter"
          variant="light"
          value="All"
          class="active"
          >All</b-button
        >
      </b-button-group>
    </div>
    <b-row>
      <b-col
        v-for="project in getFilteredProjects()"
        :key="project.id"
        lg="3"
        md="4"
        sm="6"
      >
        <project :project_data="project"></project>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Project from "@/components/Project.vue";

export default {
  name: "Projects",
  components: {
    Project,
  },
  props: ["page"],
  data() {
    return {
      filter: "All",
    };
  },
  created() {
    this.page.get_projects = this.page.get_projects
      .filter((p) => p.breast)
      .sort(this.compare);
    window.addEventListener("resize", this.handleButtonGroup);
  },
  mounted() {
    this.$nextTick(() => {
      this.handleButtonGroup();
    });

    let tempActive = this.page.get_projects.filter(function(project) {
      return project.active === true && project.breast === true;
    });

    if (tempActive.length === 0)
      document.getElementById("active-btn").disabled = true;

    let tempConcluded = this.page.get_projects.filter(function(project) {
      return project.active === false && project.breast === true;
    });

    if (tempConcluded.length === 0)
      document.getElementById("concluded-btn").disabled = true;
  },
  methods: {
    getFilteredProjects() {
      switch (this.filter) {
        case "Active": {
          return this.page.get_projects.filter(function(project) {
            return project.active === true && project.breast === true;
          });
        }
        case "Concluded": {
          return this.page.get_projects.filter(function(project) {
            return project.active === false && project.breast === true;
          });
        }
        default: {
          return this.page.get_projects.filter(function(project) {
            return project.breast === true;
          });
        }
      }
    },
    handleFilter: function(event) {
      let buttons = document.getElementById("project-filter").children;
      for (let i = 0; i < buttons.length; i++)
        buttons[i].classList.remove("active");
      event.target.classList.add("active");
      // console.log(event.target.value);
      this.filter = event.target.value;
    },
    handleButtonGroup() {
      let buttonGroup = document.getElementById("project-filter");
      if (buttonGroup == null) return;

      if (window.innerWidth < 768) {
        buttonGroup.classList.add("btn-group-vertical");
        buttonGroup.classList.remove("btn-group");
      } else {
        buttonGroup.classList.remove("btn-group-vertical");
        buttonGroup.classList.add("btn-group");
      }
    },
    compare: function(a, b) {
      if (a.active && !b.active) {
        return -1;
      } else if (!a.active && b.active) {
        return 1;
      } else {
        if (parseInt(a.begins_at, 10) < parseInt(b.begins_at, 10)) {
          return 1;
        } else if (parseInt(a.begins_at, 10) > parseInt(b.begins_at, 10)) {
          return -1;
        } else {
          if (a.display_title < b.display_title) return -1;
          else return 1;
        }
      }
    },
  },
};
</script>

<style lang="scss">
#projects {
  /*
  [class*="col-"]:nth-child(n + 4) {
    margin-top: 3em;
  }
  */

  #project-filter * {
    box-shadow: none !important;
  }

  /*
  @include media-breakpoint-down(md) {
    [class*="col-"]:nth-child(n + 3) {
      margin-top: 3em;
    }
  }

  @include media-breakpoint-down(sm) {
    [class*="col-"]:not(:first-child) {
      margin-top: 3em;
    }

    #project-filter {
      width: 100%;
      margin-top: 1em;
    }
  }
  */
}
</style>
